<template>
  <div id="karta" class="karta">
    <div class="circle-line"
      v-for="(question, index) in questions"
      :key="index"
      :class="{ hasBeen: atQuestion >= index }"
    >
      <div class="circle"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheKarta',
  data () {
    return {
      questions: new Array(11)
    }
  },
  props: ['atQuestion'],
  computed: {},
  methods: {},
  mounted () {
  },
  components: {}
}
</script>

<style scoped>

.circle-line {
  display: inline-block;
  height: 0.5vw;
  background-color: #B4B4B4;
  width: 7.2vw;
  text-align: right;
  position: relative;
}
.circle {
  height: 2.1vw;
  width: 2.1vw;
  border-radius: 100px;
  border: 0.5vw solid #B4B4B4;
  display: inline-block;
  background-color: #fff;
  top: -1.2vw;
  right: 0;
  position: absolute;
}
.circle-line:first-child {
  text-align: left;
  width: 2.4vw;
}
.circle-line:last-child {
}
.hasBeen {
  background-color: #DB3254;
}
.hasBeen .circle {
  background-color: #DB3254;
  border-color: #DB3254;
}
@media screen and (min-width: 480px) {
  .circle-line {
    height: 1px;
    width: 31px;
    margin-right: 13px;
    background-color: #fff;
    position: relative;
  }
  .circle {
    left: -14px;
    height: 13px;
    width: 13px;
    border: 1px solid #fff;
    background-color: transparent;
    top: -6px;
  }
  .circle-line:first-child {
    width: 30px;
  }
  .circle-line:last-child {
    width: 0;
  }
  .hasBeen {
    background-color: #fff;
  }
  .hasBeen .circle {
    background-color: #fff;
    border-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheKarta.vue